import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import postedPostsReducer from '../reducers/postedPostsReducer';

const configureStore = (railsProps) => (
  createStore(postedPostsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
